import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

export interface BlogAskADemoContentProps extends DefaultBsComponent {
  type?: 'text' | 'image';
}
export const BlogAskADemoContent = ({
  children,
  className,
  type = 'text',
  as: Component = 'div',
  ...props
}: BlogAskADemoContentProps) => {
  return (
    <Component
      {...props}
      className={classNames(
        'AskADemoContent',
        className,
        'w-full p-24 flex flex-col',
        type === 'image'
          ? 'md:w-1/2 items-start md:items-stretch justify-center'
          : 'sm:flex-row sm:justify-between items-center',
      )}
    >
      {children}
    </Component>
  );
};
